var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMemo } from "@discovery/common-dplus/lib/hooks";
import { SonicImage as CoreSonicImage } from "@discovery/components-luna/lib/components/atoms/image";
import { memo } from "react";
export const SonicImage = memo(CoreSonicImage);
const densities = [1, 2, 4];
export const SonicImageDplus = memo((_a) => {
    var { className, blur, format, quality = 85, src, width } = _a, rest = __rest(_a, ["className", "blur", "format", "quality", "src", "width"]);
    /** Sonic accepts floating point blur and quality, but not width..  */
    const bf = useMemo(() => (blur ? `&bf=${blur}` : ""), [blur]);
    const f = useMemo(() => (format ? `&f=${format}` : ""), [format]);
    const q = useMemo(() => (quality ? `&q=${quality}` : ""), [quality]);
    const p = "&p=true";
    const srcSet = densities
        .map((d) => `${src}?w=${Math.ceil(width * d)}${bf}${f}${p}${q} ${d}x`)
        .join(",");
    /** Do NOT change to `alt`, `concat` seems to be a mangitude faster */
    return (React.createElement("img", Object.assign({}, rest, { className: className, srcSet: srcSet, loading: "lazy" })));
});

